import React, { useEffect, useRef } from "react";
import { Buttons } from "../Buttons";
import { FaArrowRightLong } from "react-icons/fa6";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useNavigate } from "react-router-dom";
import product from "../../assets/product.mp4";
gsap.registerPlugin(ScrollTrigger);

const Essence = ({ data }) => {
  // const videoRef = useRef(null);
  // const textRef = useRef(null);
  // const buttonRef = useRef(null);
  const navigate = useNavigate();

  // useEffect(() => {
  //   gsap.from(videoRef.current, {
  //     x: 100,
  //     opacity: 0,
  //     duration: 1.2,
  //     ease: "power3.out",
  //     scrollTrigger: {
  //       trigger: videoRef.current,
  //       start: "top 80%",
  //       toggleActions: "play none none reverse",
  //     },
  //   });

  //   gsap.from(textRef.current, {
  //     x: -100,
  //     opacity: 0,
  //     duration: 1.2,
  //     ease: "power3.out",
  //     scrollTrigger: {
  //       trigger: textRef.current,
  //       start: "top 80%",
  //       toggleActions: "play none none reverse",
  //     },
  //   });

  //   gsap.from(buttonRef.current, {
  //     scale: 0.8,
  //     opacity: 0,
  //     duration: 1,
  //     ease: "back.out(1.7)",
  //     scrollTrigger: {
  //       trigger: buttonRef.current,
  //       start: "top 85%",
  //       toggleActions: "play none none reverse",
  //     },
  //   });
  // }, []);

  return (
    <div className="bg-white overflow-x-hidden flex flex-col md:flex-row justify-center items-center py-3 gap-8 md:gap-16 px-2 md:px-16">
      {/* Video */}
      <div
        className="w-full md:w-1/2 flex justify-center"
        // ref={videoRef}
      >
        <video
          src={"https://dev-designversestudios.com/video/product.mp4"}
          // src={product}
          autoPlay
          loop
          muted
          playsInline
          className="w-full max-w-full h-auto  md:h-[600px] rounded-[20px] object-contain"
        />
      </div>

      {/* Text */}
      <div
        className="w-full md:w-1/2 flex flex-col justify-center  gap-6"
        // ref={textRef}
      >
        <h2 className="font-syne text-3xl md:text-5xl font-bold text-gradient-white leading-tight ">
          {data?.title}
        </h2>
        <p className="font-outfit text-black text-base  md:text-lg font-light leading-relaxed ">
          {data?.detail}
        </p>
        <div
          className="w-[250px] md:w-64 "
          // ref={buttonRef}
        >
          <Buttons
            title="Shop the Collection"
            handleClick={() => navigate("/fragrance")}
            icon={<FaArrowRightLong />}
          />
        </div>
      </div>
    </div>
  );
};

export default Essence;
